/**
 * Created by jiachenpan on 16/11/18.
 * Update by  liubaorui on 22/11/14.
 * @desc 包含普通正则验证 + 基于 Element 表单验证.  修改原始文件添加了表单验证
 */

import { checkSfzh } from '@/basic-common/util/common.js'

// ==================== 表单验证类 ==============================

export default {
  // 手机号
  validatorPhone: function (rule, value, callback) {
    if (!value) {
      rule.required === true ? callback(new Error('请输入')) : callback();
    }
    else if (!/^[1]([3-9])[0-9]{9}$/.test(value)) {
      callback(new Error('手机号格式错误'))
    } else {
      callback()
    }
  },
  // 正整数>0
  positiveInteger: function (rule, value, callback) {
    let reg = /^[+]?([1-9]\d*)$/g;
    if (!value.toString()) {
      rule.required === true ? callback(new Error('请输入')) : callback();
    } else if (!reg.test(value)) {
      callback(new Error('支持>0且是整数'));
    } else {
      callback();
    }
  },
  // 正整数>0
  positiveExistInteger: function (rule, value, callback) {
    let reg = /^[+]{0,1}(\d+)$/g;
    if (!value) {
      rule.required === true ? callback(new Error('请输入')) : callback();
    } else if (!reg.test(value)) {
      callback(new Error('支持>0且是整数'));
    } else if (value <= 0) {
      callback(new Error('支持>0且是整数'));
    }
    else {
      callback();
    }
  },
  // 正整数且可输入-1
  posIntAndMinusOne: function (rule, value, callback) {
    let reg = /^(-1|[1-9]\d*)$/
    if (!value.toString()) {
      rule.required === true ? callback(new Error('请输入')) : callback();
    } else if (!reg.test(value)) {
      callback(new Error('仅支持正整数或-1'));
    }
    else {
      callback();
    }
  },

  // 整数≥0
  positiveThanZero: function (rule, value, callback) {
    let reg = /^[+]{0,1}(\d+)$/g;
    if (!value.toString()) {
      rule.required === true ? callback(new Error('请输入')) : callback();
    } else if (!reg.test(value)) {
      callback(new Error('支持≥0且是整数'));
    } else {
      callback();
    }
  },
  // 正数
  valipositive: function (rule, value, callback) {
    let reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
    if (rule.required === true && !value && value !== 0) {
      callback(new Error('请输入'));
    } else if (!reg.test(value)) {
      callback(new Error('格式错误，请输入正确的正数'));
    } else if (String(value).length > 15) {
      callback(new Error('长度超限'));
    }
    else {
      callback();
    }
  },
  // 正数且大于0
  valiExistpositive: function (rule, value, callback) {
    let reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
    if (!value && value !== 0) {
      rule.required === true ? callback(new Error('请输入')) : callback();
    } else if (!reg.test(value) || Number(value) < 1) {
      callback(new Error('格式错误，不支持0或负数'));
    } else if (String(value).length > 16) {
      callback(new Error('长度超限'));
    }
    else {
      callback();
    }
  },
  //  正负整数，不为0
  integerNumE0: function (rule, value, callback) {
    let reg = /^(-)?[1-9]\d*$/;
    if (!reg.test(value)) {
      callback(new Error('需为不等于0的整数'));
    }
    else if (String(value).length > 16) {
      callback(new Error('长度超限'));
    }
    callback()
  },
  //  正负整数，且可以为0
  integerNum: function (rule, value, callback) {
    let reg = /^(-)?([1-9]\d*|0)$/;
    if (!reg.test(value)) {
      callback(new Error('需为整数'));
    }
    else if (String(value).length > 16) {
      callback(new Error('长度超限'));
    }
    callback()
  },

  // 非必填正负整数，且可以为0
  notReqIntegerNum: function (rule, value, callback) {
    let reg = /^(-)?([1-9]\d*|0)$/;
    if (!value) {
      rule.required === true ? callback(new Error('请输入内容')) : callback();
    } else if (!reg.test(value.toUpperCase())) {
      callback(new Error('需为整数'));
    }
    else {
      callback();
    }
  },

  // 正数且保留2位小数(大于0)
  positiveNum2: function (rule, value, callback) {
    // let reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/;
    let reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;
    if (!validatenull(value)) {
      if (!reg.test(Number(value))) {
        callback(new Error('需为正数且最多保留两位小数'));
      }
      else if (String(value).length > 16) {
        callback(new Error('长度超限'));
      }
      callback()
    } else {
      rule.required ? callback(new Error('请输入')) : callback();
    }
  },
  // 正数且保留3位小数(大于0)
  positiveNum3: function (rule, value, callback) {
    // let reg = /(^[1-9](\d+)?(\.\d{1,3})?$)|(^0$)|(^\d\.\d{1,3}$)/;
    let reg = /(^[1-9](\d+)?(\.\d{1,3})?$)|(^\d\.\d{1,3}$)/;
    if (!validatenull(value)) {
      if (!reg.test(Number(value))) {
        callback(new Error('需为正数且最多保留三位小数'));
      }
      else if (String(value).length > 16) {
        callback(new Error('长度超限'));
      }
      callback()
    } else {
      rule.required ? callback(new Error('请输入')) : callback();
    }
  },
  // 正数且保留4位小数(大于0)
  positiveNum4: function (rule, value, callback) {
    // let reg = /^\d+(?:\.\d{1,4})?$/;
    let reg = /(^[1-9](\d+)?(\.\d{1,4})?$)|(^\d\.\d{1,4}$)/;
    if (!validatenull(value)) {
      if (!reg.test(Number(value))) {
        callback(new Error('需为正数且最多保留四位小数'));
      }
      else if (String(value).length > 16) {
        callback(new Error('长度超限'));
      }
      callback()
    } else {
      rule.required ? callback(new Error('请输入')) : callback();
    }
  },

  // 正数且保留6位小数
  positiveNum6: function (rule, value, callback) {
    let reg = /^([0](\.\d{1,6}))$|^([1-9][0-9]*(\.\d{1,6})?)$/;
    if (!value && value !== 0) {
      callback(new Error('请输入内容'));
    } else if (!reg.test(value)) {
      callback(new Error('需为正数且最多保留六位小数'));
    }
    else if (String(value).length > 15) {
      callback(new Error('长度超限'));
    }
    else {
      callback();
    }
  },

  // 大于等于0且保留2位小数(大于等于0)
  validatorNum2: function (rule, value, callback) {
    let reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/;
    if (!validatenull(value)) {
      if (!reg.test(value)) {
        callback(new Error('需为正数且最多保留两位小数'));
      }
      else if (String(value).length > 16) {
        callback(new Error('长度超限'));
      }
      callback()
    } else {
      rule.required ? callback(new Error('请输入')) : callback();
    }
  },
  // 大于等于0且保留3位小数(大于等于0)
  validatorNum3: function (rule, value, callback) {
    let reg = /(^[1-9](\d+)?(\.\d{1,3})?$)|(^0$)|(^\d\.\d{1,3}$)/;
    if (!validatenull(value)) {
      if (!reg.test(value)) {
        callback(new Error('需为正数且最多保留三位小数'));
      }
      else if (String(value).length > 16) {
        callback(new Error('长度超限'));
      }
      callback()
    } else {
      rule.required ? callback(new Error('请输入')) : callback();
    }
  },
  // 保留3位小数可以为负数，不可以为0
  decimalNum3: function (rule, value, callback) {
    let reg = /^(-)?([1-9]\d*(\.\d{1,3})?|(0(\.(00[1-9]|0[1-9]\d?|[1-9]\d{0,2}))))$/;
    if (!validatenull(value)) {
      if (!reg.test(value)) {
        callback(new Error('需为不等于0的数字且最多保留三位小数'));
      }
      else if (String(value).length > 16) {
        callback(new Error('长度超限'));
      }
      callback()
    } else {
      rule.required ? callback(new Error('请输入')) : callback();
    }
  },
  // 保留3位小数可以为负数，可以为0
  decimalNum3H0: function (rule, value, callback) {
    let reg = /^(-)?([1-9]\d*|0)(\.\d{1,3})?$/;
    if (!validatenull(value)) {
      if (!reg.test(value)) {
        callback(new Error('需为数字且最多保留三位小数'));
      }
      else if (String(value).length > 16) {
        callback(new Error('长度超限'));
      }
      callback()
    } else {
      rule.required ? callback(new Error('请输入')) : callback();
    }
  },
  // 大于零的三位小数，（大于0）
  threeDecimalNumber: function (rule, value, callback) {
    let reg = /^([1-9]\d*(\.\d{1,3})?|(0(\.(00[1-9]|0[1-9]\d?|[1-9]\d{0,2}))))$/;
    if (!validatenull(value)) {
      if (!reg.test(value)) {
        callback(new Error('需为大于0的数字且最多保留三位小数'));
      }
      else if (String(value).length > 16) {
        callback(new Error('长度超限'));
      }
      callback()
    } else {
      rule.required ? callback(new Error('请输入')) : callback();
    }
  },
  // 大于等于0且保留4位小数(大于等于0)
  validatorNum4: function (rule, value, callback) {
    let reg = /^\d+(?:\.\d{1,4})?$/;
    if (!validatenull(value)) {
      if (!reg.test(value)) {
        callback(new Error('需为正数且最多保留四位小数'));
      }
      else if (String(value).length > 16) {
        callback(new Error('长度超限'));
      }
      callback()
    } else {
      rule.required ? callback(new Error('请输入')) : callback();
    }
  },

  // 任意数字
  isNum: function (rule, value, callback) {
    if (!value && value !== 0) {
      rule.required === true ? callback(new Error('请输入')) : callback();
    } else if (isNaN(Number(value))) {
      callback(new Error('请输入合法的数字'));
    }
    else if (String(value).length > 15) {
      callback(new Error('长度超限'));
    }
    else {
      callback();
    }
  },
  //表名定制验证 必须包含下划线  下划线数量<=2   下划线不能开头或结尾
  underline: function (rule, value, callback) {
    if (value) {
      let err = false;
      (value[0] == '_' || value[value.length - 1] == '_') && (err = true);
      (!value.includes("_")) && (err = true);
      (value.includes("_") && value.split('_').length > 3) && (err = true);
      if (err) callback(new Error('数据格式校验不通过'))
      else callback();
    } else {
      callback();
    }
  },

  //  身份证号
  validateIdNo: function (rule, value, callback) {
    let theId = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (!value) {
      rule.required === true ? callback(new Error('请输入')) : callback();
    } else {
      if (!theId.test(value)) {
        callback(new Error("请输入正确的身份证号"));
        return
      }
      if (checkSfzh(value)) {
        callback();
      } else {
        callback(new Error("校验位有误，请输入有效的身份证号"));
      }
    }
  },
  // 车牌号
  isPlateNo: function (rule, value, callback) {
    // let isPhone = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z](([0-9]{5}[ADF])|([ADF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/
    let isPhone = /^((^(京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼)[A-Z]{1}[A-Z0-9]{5}[A-Z0-9挂学警港澳试超使领北南军海空外]{1}$)|(^(京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼)[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳试超使领北南军海空外]{1}$))$/
    if (!value) {
      rule.required === true ? callback(new Error('请输入')) : callback();
    } else if (!isPhone.test(value.toUpperCase())) {
      callback(new Error('请输入正确的车牌号'));
    } else if (String(value).length > 8) {
      callback(new Error('请输入正确的车牌号'));
    }
    else {
      callback();
    }
  },

  // 手机号码非必填校验
  notRequiredPhone: function (rule, value, callback) {
    let isPhone = /^[1]([3-9])[0-9]{9}$/;
    if (!value) {
      rule.required === true ? callback(new Error('请输入内容')) : callback();
    } else if (!isPhone.test(value.toUpperCase())) {
      callback(new Error('手机号格式错误'));
    }
    else {
      callback();
    }
  },

  // 邮箱非必填校验
  notRequiredEmail: function (rule, value, callback) {
    let isPhone = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/;
    if (!value) {
      rule.required === true ? callback(new Error('请输入')) : callback();
    } else if (!isPhone.test(value.toUpperCase())) {
      callback(new Error('邮箱格式错误'));
    }
    else {
      callback();
    }
  },
  // 网址
  isUrl: function (rule, value, callback) {
    let Url = /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/;
    if (value === '') {
      callback(new Error('请输入内容'));
    } else if (!Url.test(value)) {
      callback(new Error('请输入正确的网址'));
    } else if (String(value).length > 50) {
      callback(new Error('长度超限'));
    }
    else {
      callback();
    }
  },
  // 名字
  valiName: function (rule, value, callback) {
    let Url = /^(?:[\u4e00-\u9fa5·]{2,16})$/;
    if (value === '') {
      callback(new Error('请输入'));
    } else if (!Url.test(value)) {
      callback(new Error('请输入正确的司机姓名'));
    } else if (String(value).length > 7) {
      callback(new Error('超度超限'));
    }
    else {
      callback();
    }
  },
  numberAndletter: function (rule, value, callback) {
    let plateNumber = /^[A-Za-z0-9]+$/
    if (plateNumber.test(value)) {
      callback()
    } else {
      callback(new Error('仅支持输入字母+数字'))
    }
  },

  // 摄像机ip
  validateIp: function (rule, value, callback) {
    let ipAddress = /^(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|[1-9])\.(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)$/
    if (!ipAddress.test(value)) {
      callback(new Error("请输入正确的IP地址"));
    } else {
      callback();
    }
  },

  // ip
  verificationIp: function (rule, value, callback) {
    const plateNumber = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
    if (plateNumber.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确IP'))
    }
  },

  // 端口号校验
  checkPort: function (rule, value, callback) {
    const reg = /^([1-9]\d{0,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
    if (reg.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确端口号'))
    }
  },

  // 社会信用代码  非必填校验
  checkSCC: function (rule, value, callback) {
    //同时支持18位和15位社会信用代码 Social Credit Code
    const regSCC = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;
    if (value) {
      if (regSCC.test(value)) {
        callback();
      } else {
        callback(new Error("社会信用代码格式有误"));
      }
    } else {
      callback();
    }
  },

  // 弱   密码定制验证 验证6-18位，需包含数字和字母
  password: function (rule, value, callback) {
    if (/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,16}$/.test(value)) {
      callback();
    } else {
      callback(new Error("密码必须由包含数字、大小写字母、特殊字符【@~$!%*?#_.】 的 8~16 位字符组成"));
    }
  }

  //中   密码定制验证 验证6-18位，需包含特殊字符、大小写字母、数字
  // password: function (rule, value, callback) {
  //   if (/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{6,18}$/.test(value)) {
  //     callback();
  //   } else {
  //     callback(new Error("密码必须由包含数字、大小写字母、特殊字符 的 6~18 位字符组成"));
  //   }
  // }

  //强   密码定制验证 验证包含数字、大小写字母、三个特殊字符八位以上以字母开头的字符
  // password: function (rule, value, callback) {
  //   // @specialLen 小于3 || 等于-1 将会引起异常
  //   const specialStr = function (str) {
  //     // 验证必须包含三个特殊字符
  //     let regsNo = str.split(''); let specialLen = 0; let speciallist = [];
  //     regsNo.forEach((item) => {
  //       // 超过三个特殊字符
  //       const regs = /[@#!$%^&*]+/g;
  //       if (regs.test(item)) {
  //         specialLen += 1
  //       }
  //       // 不能有同样的三个特殊字符
  //       const reg = /[@#!$%^&*]+/g;
  //       if (reg.test(item)) {
  //         speciallist.push(item)
  //       }
  //     });
  //     // 所有的特殊字符出现次数对象的  Object.values 只包括特殊字符。 如果需要全部字符更换数据源为 regsNo.
  //     Object.values(speciallist.reduce((res, c) => { res[c] ? res[c]++ : res[c] = 1; return res }, {})).forEach((item) => {
  //       if (item > 2) {
  //         specialLen = -1
  //       }
  //     })
  //     return specialLen
  //   }
  //   // 验证不能有超过三个连续字符
  //   const LxStr = function (str) {
  //     let arr = str.split('');
  //     let flag = true;
  //     for (var i = 1; i < arr.length - 1; i++) {
  //       let firstIndex = arr[i - 1].charCodeAt();
  //       let secondIndex = arr[i].charCodeAt();
  //       let thirdIndex = arr[i + 1].charCodeAt();
  //       if ((thirdIndex - secondIndex == 1) && (secondIndex - firstIndex == 1)) {
  //         flag = false;
  //       }
  //     }
  //     return flag;
  //   };
  //   // 验证不能有超过三个相同字符
  //   const reg = /(\w)*(\w)\2{2}(\w)*/g;
  //   // 数字、大小写字母、特殊字符八位
  //   const reg2 = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,}/
  //   if (reg.test(value) || !LxStr(value) || !LxStr(value.split('').reverse().join('')) || specialStr(value) == -1) {
  //     callback(new Error('密码中不能包含三个及以上的连续、相邻或相同字符'))
  //   } else if (!reg2.test(value) || specialStr(value) < 3 || !(/[A-z]/.test(value[0]) && value[0] !== '^')) {
  //     callback(new Error('密码必须由包含数字、大小写字母、三个特殊字符八位以上以字母开头的字符组成'))
  //   }
  //   else {
  //     callback();
  //   }
  // }
}

// ========================== END ==============================


//========================== 普通正则类 =========================

export function isvalidUsername (str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri*/
export function validateURL (textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}
/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/* 小写字母*/
export function validateLowerCase (str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase (str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets (str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}
/*验证pad还是pc*/
export const vaildatePc = function () {
  const userAgentInfo = navigator.userAgent;
  const Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"
  ];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail (email) {
  const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * 判断身份证号码
 */
export function cardid (code) {
  let list = [];
  let result = true;
  let msg = '';
  let city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 "
  };
  if (!validatenull(code)) {
    if (code.length == 18) {
      if (!code || !/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)) {
        msg = "证件号码格式错误";
      } else if (!city[code.substr(0, 2)]) {
        msg = "地址编码错误";
      } else {
        //18位身份证需要验证最后一位校验位
        code = code.split('');
        //∑(ai×Wi)(mod 11)
        //加权因子
        let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        //校验位
        let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2, 'x'];
        let sum = 0;
        let ai = 0;
        let wi = 0;
        for (let i = 0; i < 17; i++) {
          ai = code[i];
          wi = factor[i];
          sum += ai * wi;
        }
        if (parity[sum % 11] != code[17]) {
          msg = "证件号码校验位错误";
        } else {
          result = false;
        }

      }
    } else {
      msg = "证件号码长度不为18位";
    }

  } else {
    msg = "证件号码不能为空";
  }
  list.push(result);
  list.push(msg);
  return list;
}
/**
 * 判断手机号码是否正确
 */
export function isvalidatemobile (phone) {
  let list = [];
  let result = true;
  let msg = '';
  let isPhone = /^0\d{2,3}-?\d{7,8}$/;
  //增加134 减少|1349[0-9]{7}，增加181,增加145，增加17[678]
  if (!validatenull(phone)) {
    if (phone.length == 11) {
      if (isPhone.test(phone)) {
        msg = '手机号码格式不正确';
      } else {
        result = false;
      }
    } else {
      msg = '手机号码长度不为11位';
    }
  } else {
    msg = '手机号码不能为空';
  }
  list.push(result);
  list.push(msg);
  return list;
}
/**
 * 判断姓名是否正确
 */
export function validatename (name) {
  let regName = /^[\u4e00-\u9fa5]{2,4}$/;
  if (!regName.test(name)) return false;
  return true;
}
/**
 * 判断是否为整数
 */
export function validatenum (num, type) {
  let regName = /[^\d.]/g;
  if (type == 1) {
    if (!regName.test(num)) return false;
  } else if (type == 2) {
    regName = /[^\d]/g;
    if (!regName.test(num)) return false;
  }
  return true;
}
/**
 * 判断是否为小数
 */
export function validatenumord (num, type) {
  let regName = /[^\d.]/g;
  if (type == 1) {
    if (!regName.test(num)) return false;
  } else if (type == 2) {
    regName = /[^\d.]/g;
    if (!regName.test(num)) return false;
  }
  return true;
}
/**
 * 判断是否为空
 */
export function validatenull (val) {
  if (typeof val == 'boolean') {
    return false;
  }
  if (typeof val == 'number') {
    return false;
  }
  if (val instanceof Array) {
    if (val.length == 0) return true;
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true;
  } else {
    if (val == 'null' || val == null || val == 'undefined' || val == undefined || val == '') return true;
    return false;
  }
  return false;
}

// ========================== END ==============================

// 车型校验
export const validateTrainType = (rule, value, callback) => {
  if (validatenull(value)) {
    callback();
    return;
  }
  const regex = /^[0-9a-zA-Z]+$/; //正则表达式
  const re = new RegExp(regex);
  if (!re.test(value)) {
    callback(new Error("车型只能输入字母或者数字"));
  } else if (value.length > 8) {
    callback(new Error("最大长度为8"));
  } else {
    callback();
  }
};
// 车号校验
export const validateTrainNo = (rule, value, callback) => {
  if (validatenull(value)) {
    callback();
    return;
  }
  const regex = /^[0-9]*$/; //正则表达式
  const re = new RegExp(regex);
  if (!re.test(value)) {
    callback(new Error("车号不能包含特殊字符、中文和英文字母"));
  } else if (value.length > 16) {
    callback(new Error("最大长度为16"));
  } else {
    callback();
  }
};
// 集装箱号校验
export const validateContainerNo = (rule, value, callback) => {
  if (validatenull(value)) {
    callback();
    return;
  }
  const regex = /^[A-Z]{4}\d{7}$/; //正则表达式：前四位为大写字母，后7位为数字
  const re = new RegExp(regex);
  if (value.length > 11) {
    callback(new Error("集装箱号最大长度为11"));
  } else if (!re.test(value)) {
    callback(new Error("集装箱号格式不正确"));
  } else {
    callback();
  }
};
// 载重校验
export const validateWeight = (rule, value, callback) => {
  if (validatenull(value)) {
    callback();
    return;
  }
  const regex =
    /^(([1-9][0-9]*\.[0-9][0-9]*)|([0]\.[0-9][0-9]*)|([1-9][0-9]*)|([0]{1}))$/; //正则表达式
  const re = new RegExp(regex);
  if (!re.test(value)) {
    callback(new Error("请输入有效数字(例：23.5)"));
  } else if (value.length > 5) {
    callback(new Error("请输入正确的数字(例：23.5)"));
  } else {
    var arr = String(value).split(".");
    if (arr.length > 1 && arr[1].length > 1) {
      callback(new Error("请保留一位小数(例：23.5)"));
    } else if (arr.length > 0 && arr[0].length > 3) {
      callback(new Error("请输入有效数字(例：23.5)"));
    } else {
      callback();
    }
  }
};